import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAppData } from '../../models';
import { SLICE_NAMES } from '../constants';

const initialState: IAppData = {
  showFullPageLoader: false,
  appReady: false,
  sidebarMobileOpen: false,
  passwordProtectionUnlocked: false,
};

const appDataSlice = createSlice({
  name: SLICE_NAMES.APP_DATA,
  initialState,
  reducers: {
    setFullPageLoader: (state, action: PayloadAction<boolean>) => {
      state.showFullPageLoader = action.payload;
    },
    setAppReady: (state, action: PayloadAction<boolean>) => {
      state.appReady = action.payload;
    },
    toggleSidebar: (state, action: PayloadAction<boolean>) => {
      state.sidebarMobileOpen = action.payload;
    },
    setPasswordProtectionUnlocked: (state, action: PayloadAction<boolean>) => {
      state.passwordProtectionUnlocked = action.payload;
    },
  },
});

export const {
  setFullPageLoader,
  setAppReady,
  toggleSidebar,
  setPasswordProtectionUnlocked,
} = appDataSlice.actions;

export const appDataReducer = appDataSlice.reducer;
